module.exports = __webpack_public_path__ + "img/logo_bg.60ce7daa.png";